import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchDictionaries } from "./action/fetch-step-one";
import { IPrograms, IStepOne, TError } from "./types/StepOne-interface";

const initialState: IStepOne = {
  ProgramId: "",
  AgentSalesDataID: "",
  Programs: {
    Programs: [],
    Regions: [],
    isLoadingPrograms: false,
    errorPrograms: [],
  },
};

export const StepOneSlice = createSlice({
  name: "StepOneSlice",
  initialState,
  reducers: {
    updateField: (
      state,
      action: PayloadAction<{
        field: keyof IStepOne;
        value: IStepOne[keyof IStepOne];
      }>
    ) => {
      const { field, value } = action.payload;
      state[field] = value as never;
    },
    resetForm: () => initialState,
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchDictionaries.pending, (state) => {
        state.Programs.isLoadingPrograms = true;
      })
      .addCase(
        fetchDictionaries.fulfilled,
        (
          state,
          action: PayloadAction<{ Programs: IPrograms[]; Regions: string[] }>
        ) => {
          state.Programs.Programs = action.payload.Programs;
          state.Programs.Regions = action.payload.Regions;
          state.Programs.isLoadingPrograms = false;
          state.Programs.errorPrograms = [];
        }
      )
      .addCase(fetchDictionaries.rejected, (state, action) => {
        state.Programs.Programs = initialState.Programs.Programs;
        state.Programs.isLoadingPrograms = false;
        state.Programs.errorPrograms = action.payload as TError;
      });
  },
});

export const { resetForm, updateField } = StepOneSlice.actions;
export default StepOneSlice.reducer;
